export const AllProvincesArray = [
    {
        name: "آذربایجان شرقی",
        state: "AE",
    },
    {
        name: "آذربایجان غربی",
        state: "AW",
    },
    {
        name: "اردبیل",
        state: "AR",
    },
    {
        name: "اصفهان",
        state: "IS",
    },
    {
        name: "البرز",
        state: "AL",
    },
    {
        name: "ایلام",
        state: "IL",
    },
    {
        name: "بوشهر",
        state: "BU",
    },
    {
        name: "تهران",
        state: "TE",
    },
    {
        name: "چهارمحال و بختیاری",
        state: "CM",
    },
    {
        name: "خراسان جنوبی",
        state: "KJ",
    },
    {
        name: "خراسان رضوی",
        state: "KV",
    },
    {
        name: "خراسان شمالی",
        state: "KS",
    },
    {
        name: "خوزستان",
        state: "KZ",
    },
    {
        name: "زنجان",
        state: "ZA",
    },
    {
        name: "سمنان",
        state: "SM",
    },
    {
        name: "سیستان و بلوچستان",
        state: "SB",
    },
    {
        name: "فارس",
        state: "FA",
    },
    {
        name: "قزوین",
        state: "QZ",
    },
    {
        name: "قم",
        state: "QM",
    },
    {
        name: "کردستان",
        state: "KD",
    },
    {
        name: "کرمان",
        state: "KE",
    },
    {
        name: "کرمانشاه",
        state: "BK",
    },
    {
        name: "کهگیلویه و بویراحمد",
        state: "KB",
    },
    {
        name: "گلستان",
        state: "GO",
    },
    {
        name: "گیلان",
        state: "GI",
    },
    {
        name: "لرستان",
        state: "LO",
    },
    {
        name: "مازندران",
        state: "MN",
    },
    {
        name: "مرکزی",
        state: "MK",
    },
    {
        name: "هرمزگان",
        state: "HG",
    },
    {
        name: "همدان",
        state: "HD",
    },
    {
        name: "یزد",
        state: "YA",
    },
  ];